import { Navigate, useParams, useLocation } from 'react-router-dom';
import type { GameVersion } from '../contexts/GameVersionContext';

interface VersionRedirectProps {
  path?: string;
}

// Get saved game version from localStorage
const getSavedVersion = (): GameVersion => {
  const saved = localStorage.getItem('gameVersion');
  return (saved === '6' || saved === '7') ? saved : '7';
};

export default function VersionRedirect({ path }: VersionRedirectProps) {
  const params = useParams();
  const location = useLocation();
  const version = getSavedVersion();

  // If path is provided, redirect to versioned path with params substituted
  if (path) {
    let targetPath = path;

    // Replace route params in path (e.g., :userId, :bingoId, etc.)
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        targetPath = targetPath.replace(`:${key}`, value);
      }
    });

    // Preserve query string
    const queryString = location.search;

    return <Navigate to={`/${version}${targetPath}${queryString}`} replace />;
  }

  // Default redirect to dashboard
  return <Navigate to={`/${version}`} replace />;
}
